import { Component } from '@opten/compiler/metadata/component';
import { PageRenderHelper } from './page-render-helper';

@Component({ className: 'js-section-scroll-progress' })
export class SectionScrollProgressComponent {
	constructor(private element: HTMLElement) {
		this.updateScrollProgress();
		window.addEventListener('scroll', () => this.updateScrollProgress());
		PageRenderHelper.onPageChange.subscribe(() => this.updateScrollProgress());
	}

	private updateScrollProgress(): void {
		const currentYOffset = window.scrollY;
		var height =
			document.documentElement.scrollHeight -
			document.documentElement.clientHeight;
		var scrolled = (currentYOffset / height) * 100;
		document.documentElement.style.setProperty('--scroll-progress', `${scrolled}%`);
	}
}
